<div class="row">
  <div class="col-md-12">
    <div class="{{ mobile_device ? 'd-block' : 'd-flex' }} align-items-center justify-content-between">
      <div>
        <p *ngIf="images_list?.length > 0 && images_list[0]?.photoHR !== null">
          Please save if you are happy with all the images displayed. High resolution will only be shown in printing modules.
        </p>
      </div>
      <button
        type="button"
        class="_primary-btn {{ mobile_device ? 'h-30 mt-2' : '' }}"
        *ngIf="images_list?.length > 0 && images_list[0]?.photoHR !== null"
        (click)="updateImages()">
        Update Images
      </button>
    </div>
  </div>

  <div class="my-3 progress mx-2" *ngIf="uploadProgress > 0">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width.%]="uploadProgress"
      [attr.aria-valuenow]="uploadProgress"
      aria-valuemin="0"
      aria-valuemax="100">
      {{ uploadProgress }}%
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between my-3">
    <p class="f-14 _fw-600">Images</p>
    <div class="d-flex align-items-center">
      <p class="mr-2">{{ images_list?.length > 0 && images_list[0]?.photoHR !== null ? 'Click to add more image' : 'Add a profile image' }}</p>
      <button class="_view-btn p-2 h-auto" type="button" (click)="addOption()" pTooltip="Click to add more image" tooltipPosition="left">
        <i class="pi pi-plus f-12"></i>
      </button>
    </div>
  </div>

  <ng-container *ngIf="images_list?.length > 0">
    <div class="w-100" *ngFor="let item of images_list; let ind = index">
      <div class="d-flex align-items-center my-2">
        <div class="d-flex align-items-start mt-2 mr-5">
          <p class="mb-2 mr-3">Default</p>
          <p-checkbox [(ngModel)]="item.isChecked" binary="true" (onChange)="updateDefaultPhoto(ind)"></p-checkbox>
        </div>
        <button (click)="removeOption(ind)" class="_view-btn p-2 h-auto mr-2" *ngIf="images_list?.length > 0">
          <i class="pi pi-times f-12"></i>
        </button>
      </div>
      <div class="profile-section mb-3">
        <div class="profile-thumb position-relative {{ mobile_device ? 'd-block' : 'd-flex' }} gap-5">
          <ng-container *ngIf="item?.photoHR; else noURL">
            <div class="user-thumbnail-placeholder position-relative {{ mobile_device ? 'my-3' : '' }}">
              <input
                #fileInputLR
                class="d-none"
                accept=".png,.jpg,.jpeg"
                type="file"
                name="profile"
                [hidden]="1"
                (change)="onSelectFileLR($event, ind)" />
              <span class="edit-icon">
                <ng-container *ngIf="item?.photoLR; else noLR">
                  <img
                    *ngIf="item?.photoLR"
                    (click)="fileInputLR.click()"
                    [src]="common_images?.edit_icon"
                    alt="edit"
                    width="14px"
                    class="d-flex align-items-center justify-content-center cursor-pointer" />
                </ng-container>
                <ng-template #noLR>
                  <i
                    class="pi pi-cloud-upload f-14 cursor-pointer text-color"
                    pTooltip="Upload Image"
                    tooltipPosition="top"
                    (click)="fileInputLR.click()"></i>
                </ng-template>
              </span>
              <span class="edit-icon1" *ngIf="item?.photoLR">
                <img
                  (click)="deleteImg(ind, 'LR')"
                  [src]="common_images?.delete_icon"
                  alt="delete"
                  width="14px"
                  class="d-flex align-items-center justify-content-center cursor-pointer" />
              </span>
              <ng-container *ngIf="item?.photoLR; else nophotoLR">
                <img src="{{ item?.photoLR?.includes('base64,') ? item?.photoLR : S3_url + item?.photoLR }}" alt="Low Resolution" class="user-img" />
                <div class="d-flex align-items-center justify-content-between">
                  <p class="mt-1 {{ item?.isHR == false ? 'text-danger' : '' }}">Low Resolution</p>
                  <p class="{{ item?.isHR == false ? 'text-danger' : '' }}">{{ upload_date }}</p>
                </div>
              </ng-container>
              <ng-template #nophotoLR>
                <div class="user-img d-flex align-items-center justify-content-center">
                  <img [src]="common_images?.image_not_found" height="100px" />
                </div>
              </ng-template>
            </div>
            <div class="user-thumbnail-placeholder position-relative" *ngIf="item?.imageChangedEvent">
              <div class="switch-button">
                <button class="{{ isCircle == true ? 'button-active-class' : 'button-non-class' }}" (click)="isCircle = !isCircle">
                  <i class="pi pi-circle f-12"></i>
                </button>
                <button class="{{ isCircle == false ? 'button-active-class' : 'button-non-class' }}" (click)="isCircle = !isCircle">
                  <i class="pi pi-stop f-12"></i>
                </button>
              </div>
              <image-cropper
                [imageChangedEvent]="item?.imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="1"
                class="mt_5"
                [roundCropper]="isCircle == true ? true : false"
                (imageCropped)="imageCropped($event, ind)">
              </image-cropper>
            </div>
            <div class="user-thumbnail-placeholder position-relative">
              <input
                #fileInputFP
                class="d-none"
                accept=".png,.jpg,.jpeg"
                type="file"
                name="profile"
                [hidden]="1"
                (change)="onSelectFileFP($event, ind)" />
              <span class="edit-icon">
                <ng-container *ngIf="item?.face_photo; else noFP">
                  <img
                    (click)="fileInputFP.click()"
                    [src]="common_images?.edit_icon"
                    alt="edit"
                    width="14px"
                    class="d-flex align-items-center justify-content-center cursor-pointer" />
                </ng-container>
                <ng-template #noFP>
                  <i
                    class="pi pi-cloud-upload f-14 cursor-pointer text-color"
                    pTooltip="Upload Image"
                    tooltipPosition="top"
                    (click)="fileInputFP.click()"></i>
                </ng-template>
              </span>
              <span class="edit-icon1" *ngIf="item?.face_photo">
                <img
                  (click)="deleteImg(ind, 'FP')"
                  [src]="common_images?.delete_icon"
                  alt="edit"
                  width="14px"
                  class="d-flex align-items-center justify-content-center cursor-pointer" />
              </span>
              <ng-container *ngIf="item?.face_photo; else nophotoface">
                <img
                  src="{{ item?.face_photo?.includes('base64,') ? item?.face_photo : S3_url + item?.face_photo }}"
                  alt="Low Resolution"
                  class="user-img" />
                <div class="d-flex align-items-center justify-content-between">
                  <p class="mt-1">Agent Face</p>
                  <p>{{ upload_date }}</p>
                </div>
              </ng-container>
              <ng-template #nophotoface>
                <div class="user-img d-flex align-items-center justify-content-center">
                  <img [src]="common_images?.image_not_found" height="100px" />
                </div>
              </ng-template>
            </div>
          </ng-container>
          <ng-template #noURL>
            <div class="user-img d-flex align-items-center justify-content-center">
              <img [src]="common_images?.image_not_found" height="100px" />
            </div>
          </ng-template>
        </div>
        <div class="mt-3 d-flex align-items-center">
          <p>Upload Image</p>
          <div class="ml-5">
            <i
              class="pi pi-cloud-upload profile-changer-up f-18 cursor-pointer"
              pTooltip="Upload Image"
              tooltipPosition="top"
              (click)="fileInput.click()"></i>
            <input #fileInput class="d-none" type="file" name="profile" accept=".png,.jpg,.jpeg" [hidden]="1" (change)="onSelectFile($event, ind)" />
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
